<template>
  <v-container>
    <Modal v-if="showOrderContractEndDateModal" max-width="1200" :show.sync="showOrderContractEndDateModal" :close="closeModal" :show-dividers="false">
      <template #title>
        <v-row class="justify-end" no-gutters>
          <v-icon @click="closeModal">mdi-close</v-icon>
        </v-row>
      </template>
      <template #text>
        <v-tabs v-model="currentTab" vertical>
          <v-tab v-for="(tab, index) in tabs" :key="`v-tab-header-${index}`" class="justify-start">
            <v-icon left>
              {{ tab.icon }}
            </v-icon>
            <span>{{ tab.label }}</span>
          </v-tab>
          
          <v-tabs-slider color="red" />
          
          <v-tabs-items v-model="currentTab">
            <v-tab-item v-for="(tab, index) in tabs" :key="`v-tab-item-${index}`">
              <component 
                v-if="(index === currentTab) || componentInDOM"
                :is="tab.component"
                :customer="customer" 
                :contract="contract" 
                :selected-order="order"
              />
            </v-tab-item>
          </v-tabs-items>
        </v-tabs>
      </template>
    </Modal>
  </v-container>
</template>

<script>
import { EventBus } from '../../mixins';
import Modal from '@/components/Modal/Modal';
import UpdateContractValidity from '@/components/order/UpdateContractValidity';
import ContractValidityHistory from '@/components/order/ContractValidityHistory';

import { requests } from '@/mixins/index';

export default {
  components: { Modal, UpdateContractValidity, ContractValidityHistory },
  mixins: [requests],
  props: {
    order: {
      type: Object,
      default: null
    },
    customer: {
      type: Object,
      default: null
    }
  },
  data () {
    return { 
      showOrderContractEndDateModal: false, 
      newEndDate: null,
      currentTab: 0,
      updatedHistory: false
    };
  },
  computed: {
    tabs () {
      return [
        { tabKey: 'updateContractValidity', icon: 'mdi-plus-circle-outline', label: 'Mettre à jour contrat validité', component: 'UpdateContractValidity' },
        { tabKey: 'contractValidityHistory', icon: 'mdi-note-edit-outline', label: 'Historique des modifications', component: 'ContractValidityHistory' },
      ];
    },
    contract () {
      if (!this.$props.order) return null;

      const orderItem = this.$props.order.order.order_items.find(item => item.customer.uuid === this.$props.customer.uuid);

      if (!orderItem) return null;

      return orderItem.contract ? {...orderItem.contract, workspace: this.$props.order.siteWorkspaceCode} : null;
    },
    componentInDOM () {
      return this.updatedHistory;
    }
  },
  mounted () {
    EventBus.$on('show-alpha-order-contract-date-modal', () => {
      this.showOrderContractEndDateModal = true;
    });

    EventBus.$on('up-to-date-contract-validity-history', async bool => {
      this.updatedHistory = bool;
    });
  },
  methods: {
    closeModal () {
      this.showOrderContractEndDateModal = false;
      this.currentTab = 0;
    }
  }
};
</script>
